import Store from '@/store'

export default [
  {
    path: '/clientes',
    name: 'clientes-index',
    beforeEnter: async (to, from, next) => {
      await Store.dispatch('getPaginateClientes')
      next()
    },
    meta: {
      title: 'Clientes',
      paginateMethod: 'getPaginateClientes',
      paginateAttr: 'paginateClientes',
      twoLines: true,
      titleAttr: item => item['nome'],
      subtitleAttr: item => item['cpf_numero'],
      routeToCreate: 'clientes-create',
      routeToEdit: 'clientes-update',
      emptyList: 'Nenhum cliente foi cadastrado.',
      avatarIcon: 'contacts',
      pageAttr: 'clientePage',
      pageCommit: 'setClientePage',
      filterAttr: 'clienteFilter',
      filterCommit: 'setClienteFilter',
      requireAuth: true
    },
    component: function () {
      return import(/* webpackChunkName: "routes" */ '@/views/paginate')
    }
  },
  {
    path: '/clientes/novo',
    name: 'clientes-create',
    beforeEnter: async (to, from, next) => {
      await Store.dispatch('getCidades')
      await Store.commit('setCliente', {
        ativo: true
      })
      next()
    },
    meta: {
      title: 'Novo cliente',
      requireAuth: true
    },
    component: function () {
      return import(/* webpackChunkName: "routes" */ '@/views/cliente/id')
    }
  },
  {
    path: '/clientes/:id',
    name: 'clientes-update',
    props: true,
    beforeEnter: async (to, from, next) => {
      await Store.dispatch('getCidades')
      await Store.dispatch('getCliente', {
        id: Number(to.params.id)
      })
      next()
    },
    meta: {
      title: 'Atualizar cliente',
      routeToEditTelefone: 'clientes-update-telefone',
      routeToAddTelefone: 'clientes-create-telefone',
      documentAttrTelefone: 'cliente',
      requireAuth: true
    },
    component: function () {
      return import(/* webpackChunkName: "routes" */ '@/views/cliente/id')
    }
  }
]
